import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { Background } from "react-imgix";

const dailyCountdownElement = document.getElementById('DailyCountdown');

const ServiceCountdownComponent = ({
    isServiceLiveNow,
    initialDaysLeft,
    initialHoursLeft,
    initialMinutesLeft,
    initialSecondsLeft,
    nextServiceTimeText,
    title = 'Next Service',
    containerClassName = '',
    textClassName = '',
    bgImage = '',
}) => {

    const [timeRemaining, setTimeRemaining] = useState({
        days: Number(initialDaysLeft),
        hours: Number(initialHoursLeft),
        minutes: Number(initialMinutesLeft),
        seconds: Number(initialSecondsLeft),
    });

    const formatTimeValue = (val) =>  String(val).padStart(2, '0');

    const decrementTime = (currentTime) => {
        let { days, hours, minutes, seconds } = currentTime;
        if (seconds > 0) {
            seconds -= 1;
        } else if (minutes > 0) {
            minutes -= 1;
            seconds = 59;
        } else if (hours > 0) {
            hours -= 1;
            minutes = 59;
            seconds = 59;
        } else if (days > 0) {
            days -= 1;
            hours = 23;
            minutes = 59;
            seconds = 59;
        }
        return { days, hours, minutes, seconds }
    };

    const updateCountdown = useCallback(() => {
        setTimeRemaining(prevTimeRemaining => decrementTime(prevTimeRemaining));
    }, []);

    useEffect( () => {
        const interval = setInterval(updateCountdown, 1000);
        return () => clearInterval(interval);
    }, [updateCountdown]);

    // home page version - Updated for daily experience & new on-demand
    return (
        <div className={`bg-[#6a4617] w-full min-h-20 rounded-b-lg !px-5 !py-4 flex justify-between gap-2 ${containerClassName}`}>
            {bgImage !== '' && (<Background
                className='h-full bg-center opacity-50 absolute inset-0 z-0 rounded-lg'
                src={bgImage}
                imgixParams={{auto: 'format', fit: 'crop'}}
                sizes='(min-width: 1280px) 454p, (min-width: 1024px) 262px, (min-width: 768px) 100vw, (min-width: 640px) 100vw, 100vw'
            />)}
            <div className="flex flex-col gap-y-1 z-20">
                { (isServiceLiveNow || (timeRemaining.days === 0 && timeRemaining.hours === 0 && timeRemaining.minutes === 0 && timeRemaining.seconds === 0)) ?
                    <div className="text-white uppercase text-sm md:text-lg tracking-wider font-bold">&#128308; LIVE NOW</div>
                    :
                    <div>
                        <h3 className={`!text-white uppercase text-base md:text-xl font-bold leading-tight md:leading-normal !mb-0 ${textClassName}`}>{ title }</h3>
                        <h4 className={`!text-[#faf9f7] text-base md:text-lg font-normal leading-tight md:leading-relaxed !mb-0 ${textClassName}`}>{ nextServiceTimeText }</h4>
                    </div>
                }
            </div>
            <div className="flex items-center gap-x-2 z-20">
                {timeRemaining.days !== 0  && (
                    <div
                        className="!py-1.5 !px-3 min-w-16 bg-[#e9e7e4] rounded inline-flex flex-col justify-start items-center">
                        <p className="text-[#4a4a4a] text-xl md:text-2xl font-medium !pb-0 !mb-0">{ formatTimeValue(timeRemaining.days) }</p>
                        <p className="text-[#6e6e6e] text-base font-medium !pb-0 !mb-0">days</p>
                    </div>
                )}
                <div
                    className="!py-1.5 !px-3 min-w-16 bg-[#e9e7e4] rounded inline-flex flex-col justify-start items-center">
                    <p className="text-[#4a4a4a] text-center text-xl md:text-2xl font-medium !pb-0 !mb-0">{ formatTimeValue(timeRemaining.hours) }</p>
                    <p className="text-[#6e6e6e] text-base font-medium !pb-0 !mb-0">hour</p>
                </div>
                <div className="!py-1.5 !px-3 min-w-16 bg-[#e9e7e4] rounded inline-flex flex-col justify-start items-center">
                    <p className="text-[#4a4a4a] text-center text-xl md:text-2xl font-medium !pb-0 !mb-0">{ formatTimeValue(timeRemaining.minutes) }</p>
                    <p className="text-[#6e6e6e] text-base font-medium !pb-0 !mb-0">min</p>
                </div>
                <div className="!py-1.5 !px-3 min-w-16 bg-[#e9e7e4] rounded inline-flex flex-col justify-start items-center">
                    <p className="text-[#4a4a4a] text-center text-xl md:text-2xl font-medium pb-0 !mb-0">{ formatTimeValue(timeRemaining.seconds) }</p>
                    <p className="text-[#6e6e6e] text-base font-medium !pb-0 !mb-0">sec</p>
                </div>
            </div>
        </div>
    )

};

export default ServiceCountdownComponent;

if (dailyCountdownElement) {
    const props = {
        isServiceLiveNow: Boolean(Number(dailyCountdownElement.getAttribute('data-isServiceLiveNow'))),
        nextServiceTimeText: dailyCountdownElement.getAttribute('data-nextServiceTimeText'),
        initialDaysLeft: dailyCountdownElement.getAttribute('data-initialDaysLeft'),
        initialHoursLeft: dailyCountdownElement.getAttribute('data-initialHoursLeft'),
        initialMinutesLeft: dailyCountdownElement.getAttribute('data-initialMinutesLeft'),
        initialSecondsLeft: dailyCountdownElement.getAttribute('data-initialSecondsLeft'),
        title: dailyCountdownElement.getAttribute('data-title') ?? 'Next Service',
        containerClassName: dailyCountdownElement.getAttribute('data-containerClassName') || '',
        textClassName: dailyCountdownElement.getAttribute('data-textClassName') || '',
        bgImage: dailyCountdownElement.getAttribute('data-bgImage') || '',
    };

    ReactDOM.render(<ServiceCountdownComponent {...props} />, dailyCountdownElement);
}
